import React from 'react';
import { careplan, careplanAssessment, solution } from '../Components/constants/Constants';

const Cover404 = React.lazy(() => import('../pages/Errors/Cover404'));
const SessionLogoutPage = React.lazy(() => import('../pages/sessionLogout'));
const Assessments = React.lazy(() => import('../pages/Assessments'));
const CarePlan = React.lazy(() => import('../pages/Careplan'));
const AuthFlow = React.lazy(() => import('../pages/AuthenticationV2/AuthFlow'));
const Solutions = React.lazy(() => import('../pages/Solutions'));
const MemberLogin = React.lazy(() => import('../pages/MemberLogin'));

const allroutes = [
    { path: '/careplan', component: <CarePlan />, pageName: careplan },
    { path: '/assessments', component: <Assessments />, pageName: careplanAssessment },
    { path: '/solution/:solutionId', component: <Solutions />, pageName: solution },
    { path: '/solution', component: <Solutions />, pageName: solution }
];

const authProtectedRoutes = (allRolesData, roleAccessData) => {
    return [...publicRoutes(), ...allroutes];
};

const publicRoutes = () => {
    return [
        { path: '/:tenant/authorize/xp/:lang?/:uniquelink/:uniquekey/:pageName/:modeId', component: <AuthFlow /> },
        { path: '/:tenant/authorize/xp/:lang?/:uniquelink/:uniquekey', component: <AuthFlow /> },
        { path: '/:tenant/authorize/:uniquelink', component: <AuthFlow /> },

        { path: '/authorize/xp/:lang?/:uniquelink/:uniquekey/:pageName/:modeId', component: <AuthFlow /> },
        { path: '/authorize/xp/:lang?/:uniquelink/:uniquekey', component: <AuthFlow /> },
        { path: '/authorize/:uniquelink', component: <AuthFlow /> },
        { path: '/member-login', component: <MemberLogin /> },
        { path: '/logout', component: <SessionLogoutPage /> }
    ];
};

export { authProtectedRoutes, publicRoutes, allroutes as allRoutesOfApplication };
